module.exports = __webpack_public_path__ + "static/media/file-pdf-icon.114686b1.svg";